import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ApplicationTypeEnum } from '@thinknet-gmbh/platform-common';
import { Loader, Typography, TYPOGRAPHY_SIZE } from '@thinknet-gmbh/platform-common-ui';

import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';
import { useGetApplicationsSetting } from 'src/hooks/applications-setting/get-applications-setting.hook';

import { ApplicationsTable } from './components/applications-table';
import { ApplicationsEdit } from './components/applications-edit';
import { ApplicationsWrapper } from './applications.styles';
import { IApplicationSetting } from './applications.interfaces';

const Applications = () => {
  const { t } = useTranslation('settings');
  const [application, setApplication] = useState<IApplicationSetting | null>(null);

  const currentCompanyId = useGetCurrentCompanyId();

  const { applicationsSettings, loading } = useGetApplicationsSetting(currentCompanyId);

  const collection = [] as IApplicationSetting[];

  Object.keys(ApplicationTypeEnum).forEach(type => {
    const application = applicationsSettings.find(
      (appl: IApplicationSetting) => String(appl?.type) === String(type)
    );

    if (application) {
      collection.push(application);
    } else {
      collection.push({
        type: type,
        email: '',
        companyId: currentCompanyId || '',
        eAUTemplateAcceptedId: '',
        eAUTemplateId: '',
        eAUTemplateRejectedId: '',
        rejectReasons: [{} as any]
      });
    }
  });

  return (
    <ApplicationsWrapper>
      <div>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('applications.labels.applications')}
        </Typography>
      </div>
      <Fragment>
        {loading ? (
          <Loader />
        ) : (
          <Fragment>
            {application ? (
              <ApplicationsEdit
                application={application}
                companyId={currentCompanyId}
                onClose={() => {
                  setApplication(null);
                }}
              />
            ) : (
              <ApplicationsTable
                collection={collection}
                onClickEdit={record => {
                  setApplication(record);
                }}
              />
            )}
          </Fragment>
        )}
      </Fragment>
    </ApplicationsWrapper>
  );
};

export default Applications;
